import { CLEAR_WEATHER_SYMBOL, DOWN_ARROW, UP_ARROW } from "../symbols.js";
export const DEFAULT_HOLD_DATA = {
    direction: "N",
    outboundRadial: 0,
    turns: "RT",
    legLength: null,
    legLengthInNm: false,
};
const specialCharacters = [CLEAR_WEATHER_SYMBOL, UP_ARROW, DOWN_ARROW];
const validCharacterRegex = /[A-Z0-9+\-*/_;.,=]/;
export function isValid4thLineCharacter(c) {
    return specialCharacters.includes(c) || validCharacterRegex.test(c);
}
//# sourceMappingURL=eramCoordination.js.map